export const TYPE_SHOP = 1;
export const TYPE_HIME = 2;
export const TYPE_STAFF = 3;
export const TYPE_DRIVER = 4;
export const TYPE_EXPENSE = 11;
export const TYPE_D_MEDIA = 12; // TYPE_MEDIA は予約拡張の種別に使われるので TYPE_D_MEDIA に変えた
export const TYPE_SC = 13;
export const TYPE_SCCMP = 14;
